import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import { GradientText } from './navbar.style';
import { breakpoints } from '../../../styles/screenSizes';

export const DropdownWrapper = styled.div`
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    inset: 0;
    top: 78px;
    z-index: 99;

    @media (max-width: ${breakpoints.md}) {
        top: 58px;
    }
`;

export const DropdownItemsContainer = styled.div`
    width: 901px;
    background-color: #fff;
    border-radius: 5px;
    border: 3px solid #dbf0ff;
    margin: 14px auto auto auto;
    display: flex;
    position: relative;
`;

export const DropdownArrow = styled.div`
    height: 20px;
    width: 20px;
    position: absolute;
    top: -10px;
    background-color: #fff;
    transform: rotate(45deg);
`;

export const CategoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0.3;
    border-right: 2px solid #eff8ff;
    transition: all 0.3s linear;
`;

export const ActiveStyle = css`
    background: linear-gradient(90deg, #ffffff 0%, #e0f2fe 100%);

    &::before {
        content: '';
        position: absolute;
        width: 2px;
        height: 100%;
        top: 0;
        right: 0;
        background-color: #1f65bc;
    }
`;

export const CategoryIconActiveStyle = css`
    filter: invert(27%) sepia(99%) saturate(1159%) hue-rotate(194deg) brightness(95%) contrast(89%);
`;

export const CategoryIcon = styled.img`
    height: 28px;
    width: 28px;
    filter: invert(30%) sepia(13%) saturate(707%) hue-rotate(176deg) brightness(95%) contrast(84%);
`;

export const CategoryLabel = styled.h4`
    color: #4b5563;
    font-weight: 500;
    line-height: 22px;
    font-size: 15px;
    font-family: Rubik, sans-serif;
`;

export const CategoryOption = styled.button`
    all: unset;
    display: flex;
    align-items: center;
    padding: 20px 36px;
    gap: 10px;
    cursor: pointer;
    position: relative;

    ${({ active }) =>
        active &&
        css`
            ${ActiveStyle}

            ${CategoryLabel} {
                color: #1f65bc;
            }

            ${CategoryIcon} {
                filter: invert(27%) sepia(99%) saturate(1159%) hue-rotate(194deg) brightness(95%)
                    contrast(89%);
            }
        `}

    &:hover {
        ${ActiveStyle}

        ${CategoryLabel} {
            color: #1f65bc;
        }

        ${CategoryIcon} {
            filter: invert(27%) sepia(99%) saturate(1159%) hue-rotate(194deg) brightness(95%)
                contrast(89%);
        }
    }
`;

export const PageLinkContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    gap: 36px;
    padding: 24px 36px;
`;

export const PageName = styled.h5`
    font-size: 16px;
    line-height: 22px;
    font-family: Rubik, sans-serif;
    font-weight: 500;
    color: #262626;

    ${({ active }) => active && GradientText}

    @media (max-width: ${breakpoints.md}) {
        font-size: 14px;
    }
`;

export const PageSubText = styled.p`
    color: #6b7280;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #6b7280;
    margin-top: 6px;

    @media (max-width: ${breakpoints.md}) {
        margin-top: 3px;
    }
`;

export const LinkWrapper = styled.div`
    cursor: pointer;

    &:hover {
        ${PageName} {
            ${GradientText}
        }
    }
`;

export const SharedLinkStyle = css`
    text-decoration: none;
    color: inherit;
    height: max-content;

    @media (max-width: ${breakpoints.md}) {
        font-size: 14px;
        line-height: 22px;
    }
`;

export const ExternalLink = styled.a`
    ${SharedLinkStyle}
`;

export const InternalLink = styled(Link)`
    ${SharedLinkStyle}
`;

export const ImgContainer = styled.div`
    background: linear-gradient(96.28deg, #0c1a68 0%, #0074fc 100%);
    border-radius: 10px;
    padding: 19px 24px;
    margin-top: 32px;

    @media (max-width: ${breakpoints.sm}) {
        display: none;
    }

    img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
`;
